<template>
  <div class="vue-c-card">
    <div
      class="credit-card"
      :class="{
        'flip-cc': isTypingCvc,
        'amex-cc': brand === 'amex',
        'dinersclub-cc': brand === 'dinersclub',
        'mastercard-cc': brand === 'mastercard',
        'visa-cc': brand === 'visa' || brand === 'visaelectron',
        'elo-cc': brand === 'elo',
        'hipercard-cc': brand === 'hipercard',
        'maestro-cc': brand === 'maestro',
        'discover-cc': brand === 'discover',
        'jcb-cc': brand === 'jcb',
        'unionpay-cc': brand === 'unionpay',
        'troy-cc': brand === 'troy',
        'dankort-cc': brand === 'dankort',
      }"
    >
      <div class="front front-background-image" :class="brand === 'discover' ? 'front_discover' : ''">
        <template v-for="item in brands">
          <div class="card-brand " :class="item" :key="item" v-show="item === brand">
            {{ screening(item) }}
            <div v-if="item === 'elo'" class="e">e</div>
            <div v-if="item === 'elo'" class="l">l</div>
            <div v-if="item === 'elo'" class="o">o</div>
            <div v-if="item === 'jcb'" class="j">J</div>
            <div v-if="item === 'jcb'" class="c">C</div>
            <div v-if="item === 'jcb'" class="b">B</div>
            <div v-if="item === 'visaelectron'" class="elec">Electron</div>
            <div class="dk" v-if="item === 'dankort'">
              <div class="d"></div>
              <div class="k"></div>
            </div>
          </div>
        </template>
        <div class="jp-card-shiny" />
        <p class="card-number" data-openreplay-obscured>
          <span v-if="number.length > 0">
            <span data-openreplay-obscured>{{ numberText(1) }}</span>
            <span>&ensp;</span>
            <span data-openreplay-obscured>{{ numberText(2) }}</span>
            <span>&ensp;</span>
            <span data-openreplay-obscured>{{ numberText(3) }}</span>
            <span>&ensp;</span>
            <span>{{ numberText(4) }}</span>
          </span>
          <span v-else>•••• •••• •••• ••••</span>
        </p>
        <p class="card-holder">{{ holder.length > 1 ? holder : 'FULL NAME' }}</p>
        <p class="card-exp">{{ exp.length > 0 ? exp : '••/••' }}</p>
      </div>
      <div class="back">
        <div class="jp-card-bar" />
        <p class="card-cvc">{{ cvc.length > 0 ? cvc : '•••' }}</p>
        <div class="jp-card-shiny" />
      </div>
    </div>
  </div>
</template>

<script>
import Payment from 'payment'

export default {
  name: 'VueCard',

  props: {
    number: String,
    holder: String,
    exp: String,
    cvc: String,
    isTypingCvc: Boolean,
  },

  data() {
    return {
      brand: '',
      brands: [
        'amex',
        'dinersclub',
        'mastercard',
        'visa',
        'visaelectron',
        'maestro',
        'hipercard',
        'discover',
        'elo',
        'jcb',
        'unionpay',
        'troy',
        'dankort',
      ],
      discover: ''
    }
  },

  watch: {
    number(newValue) {
      this.setCardFlag(newValue)
    },
  },

  methods: {
    /**
     * 号码文案
     * @param num {Number} 第几段号码
     * @return {String} 分割好对应的号码
     */
    numberText(num) {
      const start = (num - 1) * 5
      const end = start + 4
      return this.number.slice(start, end)
    },

    setCardFlag(cardNumber) {
      const cNumber = cardNumber.replace(/\s/g, '')
      const cardType = Payment.fns.cardType(cNumber)
      this.brand = cardType
    },

    screening(val) {
      if (val === 'hipercard') return 'Hipercard'
      if (val === 'unionpay') return 'UnionPay'
      if (val === 'discover') return 'discover'
      if (val === 'maestro') return 'maestro'
      if (val === 'mastercard') return 'mastercard'
      if (val === 'troy') return 'troy'
      if (val === 'visa' || val === 'visaelectron') return 'visa'
      return ''
    }
  },
}
</script>

<style lang="scss" scoped>
.vue-c-card {
  perspective: 800px;

  .credit-card,
  .front,
  .back {
    width: 400px;
    height: 200px;

    @media (max-width: 500px) {
      width: 100%;
      height: 200px;
    }
  }

  .front-background-image {
    overflow: hidden;
    background-image: repeating-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0) 0.02778rem,
        rgba(255, 255, 255, 0.03) 0.05556rem,
        rgba(255, 255, 255, 0.04) 0.08333rem,
        rgba(255, 255, 255, 0.05) 0.11111rem
      ),
      repeating-linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.05) 0.02778rem,
        rgba(255, 255, 255, 0) 0.05556rem,
        rgba(255, 255, 255, 0.04) 0.08333rem,
        rgba(255, 255, 255, 0.03) 0.11111rem
      ),
      repeating-linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0.02778rem,
        rgba(255, 255, 255, 0.03) 0.05556rem,
        rgba(255, 255, 255, 0.04) 0.08333rem,
        rgba(255, 255, 255, 0.05) 0.11111rem
      ),
      repeating-linear-gradient(
        210deg,
        rgba(255, 255, 255, 0) 0.02778rem,
        rgba(255, 255, 255, 0.03) 0.05556rem,
        rgba(255, 255, 255, 0.04) 0.08333rem,
        rgba(255, 255, 255, 0.05) 0.11111rem
      ),
      linear-gradient(
        -25deg,
        rgba(255, 255, 255, 0) 50%,
        rgba(255, 255, 255, 0.2) 70%,
        rgba(255, 255, 255, 0) 90%
      );
  }

  .front_discover {
    &::after {
        content: " ";
        display: block;
        background-color: #FF6600;
        background-image: linear-gradient(#FF6600, #ffa366, #FF6600);
        height: 1.38889rem;
        width: 1.38889rem;
        border-radius: 0.69444rem;
        position: absolute;
        left: 100%;
        top: 15%;
        margin-left: -0.69444rem;
        box-shadow: inset 0.02778rem 0.02778rem 0.08333rem 0.02778rem rgba(0, 0, 0, 0.5);
      }
  }

  .credit-card {
    position: relative;
    margin-bottom: 20px;
    background: #bdbdbd;
    color: #fff;
    border-radius: 6px;
    transition: transform 0.5s;
    transform-style: preserve-3d;
    text-align: left;

    &.flip-cc {
      transform: rotateY(180deg);
    }

    &.visa-cc {
      background: #191278;
    }

    &.mastercard-cc {
      background: #0061A8;
    }

    &.dinersclub-cc {
      background: #999;
    }

    &.amex-cc {
      background: #108168;
    }

    &.elo-cc {
      background: #6f6969;
    }

    &.discover-cc {
      background: #86B8CF;
    }

    &.maestro-cc {
      background: #0b2c5f;
    }

    &.hipercard-cc {
      background: #770304;
    }

    &.jcb-cc {
      background: #cb8000;
    }

    &.unionpay-cc {
      background: #987c00;
    }

    &.troy-cc {
      background: #01adba;
    }

    &.dankort-cc {
      background: #0055C7;
    }

    .front,
    .back {
      position: absolute;
      top: 0;
      left: 0;
      backface-visibility: hidden;
    }

    .front {
      z-index: 2;
      transform: rotateY(0deg);
    }

    .back {
      transform: rotateY(-180deg);

      &:after {
        content: '';
        position: absolute;
        top: 40%;
        left: 2%;
        display: block;
        width: 80%;
        height: 16%;
        background-color: #fff;
        background-image: linear-gradient(#fff, #fff);
      }

      .jp-card-shiny {
        position: absolute;
        top: 66%;
        left: 2%;
      }
    }

    .jp-card-shiny {
      position: relative;
      top: 40px;
      left: 35px;
      width: 50px;
      height: 35px;
      border-radius: 5px;
      background: #ccc;

      &:before {
        content: ' ';
        position: absolute;
        top: 20%;
        display: block;
        width: 70%;
        height: 60%;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        background: #d9d9d9;
      }
    }

    .card-number,
    .card-holder,
    .card-exp,
    .card-cvc {
      position: absolute;
      font-family: monospace;
      letter-spacing: 1px;
      font-size: 20px;
      font-weight: 600;

      @media (max-width: 500px) {
        font-size: 14px !important;
      }
    }

    .card-brand {
      position: absolute;
      top: 15px;
      right: 20px;
      height: 50px;
    }

    .jp-card-bar {
      position: absolute;
      top: 10%;
      left: 0;
      right: 0;
      height: 20%;
      background-color: #444;
      background-image: linear-gradient(#444, #333);
    }

    .card-number {
      top: 100px;
      left: 35px;
      width: 350px;
      height: 23px;
      text-overflow: ellipsis;
      overflow-x: hidden;
      white-space: nowrap;
      font-size: 23px;
      letter-spacing: 5px;
    }

    .card-holder {
      top: 152px;
      left: 35px;
      width: 240px;
      height: 45px;
      letter-spacing: 1px;
      text-transform: uppercase;
      text-overflow: ellipsis;
      overflow-x: hidden;

      @media (max-width: 500px) {
        width: 60%;
        height: 45px;
      }
    }

    .card-exp {
      top: 140px;
      right: 20px;
      text-overflow: ellipsis;

      &:after,
      &:before {
        font-size: 4px;
        white-space: pre;
        display: block;
        opacity: 0.5;
        line-height: 12px;
      }

      &:before {
        content: 'MONTH/YEAR';
        margin-bottom: 2px;
        text-transform: uppercase;
      }

      &:after {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        content: 'valid \A thru';
        margin-left: -46px;
        margin-top: -25px;
        width: 45px;
        text-align: center;
        white-space: break-spaces;
      }
    }

    .card-cvc {
      top: 76px;
      right: 0;
      padding: 10px;
      width: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      z-index: 2;
    }
  }

  .troy {
    margin-top: 0.13889rem;
    text-transform: lowercase;
    color: #fff;
    text-align: center;
    font-weight: 700;
    font-size: 0.66667rem;
    line-height: 0.5rem;
    font-style: italic;
  }

  .visaelectron {
    width: 1.66rem;
    height: 1rem !important;
    box-shadow: 0 0 0 0.05rem rgb(255 255 255 / 30%);
    background: white;
    text-transform: uppercase;
    color: #1A1876;
    text-align: center;
    font-weight: bold;
    font-size: 0.41rem;
    line-height: 0.5rem;

    .elec {
      margin-right: 0.02rem;
      float: right;
      font-family: arial;
      font-size: 0.25rem;
      line-height: 0.25rem;
      text-transform: none;
    }

    &::before {
      content: " ";
      display: block;
      width: 100%;
      height: 26%;
      background: #1A1876;
    }

    &::after {
      content: " ";
      display: block;
      width: 100%;
      height: 25%;
      background: #E79800;
    }
  }

  .dankort {
    padding: 0.08rem;
    width: 1.66rem;
    height: 1rem !important;
    border-radius: 0.22rem;
    border: #000000 0.02rem solid;
    background-color: #FFF;
    box-shadow: 0 0 0 0.05rem rgb(255 255 255 / 30%);

    .dk {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;

      &::before {
        content: " ";
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        background-color: #ED1C24;
        border-radius: 0.16667rem;
      }

      &::after {
        content: " ";
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -0.21rem;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0.19rem 0.19rem 0.27rem 0;
        border-color: transparent #ED1C24 transparent transparent;
        z-index: 1;
      }

      .d,.k {
        position: absolute;
        top: 50%;
        width: 50%;
        display: block;
        height: 0.42rem;
        margin-top: -0.21rem;
        background: white;
      }

      .d {
        left: 0;
        border-radius: 0 0.22rem 0.27rem 0;

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          display: block;
          margin: -0.08rem 0 0 -0.11rem;
          width: 0.19rem;
          height: 0.13rem;
          background: #ED1C24;
          border-radius: 0.05rem 0.11rem 0.16rem 0;
          z-index: 1;
        }
      }

      .k {
        right: 0;

        &::before,
        &::after {
          content: '';
          position: absolute;
          right: 50%;
          margin-right: -0.02rem;
          width: 0;
          height: 0;
          border-style: solid;
        }

        &::before {
          top: 0;
          border-width: 0.22rem 0.13rem 0 0;
          border-color: #ED1C24 transparent transparent transparent;
        }

        &::after {
          bottom: 0;
          border-width: 0 0.13rem 0.22rem 0;
          border-color: transparent transparent #ED1C24 transparent;
        }
      }
    }
  }

  .maestro {
    width: 62px;
    font-size: 12px;
    font-weight: 600;
    line-height: 85px;
    text-align: center;
    letter-spacing: 1px;

    &::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 1rem;
      height: 1rem;
      background: #eb001b;
      border-radius: 0.5rem;
      z-index: -2;
    }

    &::after {
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      width: 1rem;
      height: 1rem;
      background: #00a2e5;
      border-radius: 0.5rem;
      opacity: 0.8;
      z-index: -1;
    }
  }

  .mastercard {
    width: 62px;
    font-size: 9px;
    font-weight: 600;
    line-height: 85px;
    text-align: center;
    letter-spacing: 1px;

    &::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 1rem;
      height: 1rem;
      background: #eb001b;
      border-radius: 0.5rem;
      z-index: -2;
    }

    &::after {
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      width: 1rem;
      height: 1rem;
      background: #FF5F00;
      border-radius: 0.5rem;
      opacity: 0.8;
      z-index: -1;
    }
  }

  .unionpay {
    width: 1.66rem;
    height: 1.11rem !important;
    background: #e21836;
    -webkit-transform: skew(-15deg);
    -moz-transform: skew(20deg);
    -o-transform: skew(20deg);
    border-radius: 0.13rem;
    font-size: 0.27rem;
    line-height: 0.91rem;
    text-align: center;
    font-family: "Sans-serif", "Microsoft Yahei", "\5FAE\8F6F\96C5\9ED1", "Hiragino Sans", "Gulim", "\5B8B\4F53";
    font-weight: bold;
    box-shadow: 0 0 0 0.05rem rgb(255 255 255 / 30%);

    &::before {
      content: " ";
      position: absolute;
      left: 0.38rem;
      width: 0.77rem;
      height: 100%;
      background: #00447c;
      border-top-left-radius: 0.13rem;
      border-bottom-left-radius: 0.13rem;
      z-index: -1;
    }

    &::after {
      content: "银联";
      position: absolute;
      left: 0.94rem;
      width: 0.72rem;
      height: 100%;
      background: #007b84;
      border-radius: 0.13rem;
      line-height: 1.5rem;
      text-indent: -0.47rem;
      z-index: -1;
    }
  }

  .elo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.38rem;
    border-radius: 100%;
    background: black;
    text-transform: lowercase;
    font-size: 0.58rem;
    font-style: normal;
    letter-spacing: 0.02rem;
    font-weight: bold;
    box-shadow: 0 0 0 0.05rem rgba(255, 255, 255, 0.3);

    .e {
      transform: rotate(-15deg);
    }

    .o {
      position: relative;
      right: 0;
      top: 3px;
      width: 0.33rem;
      height: 0.33rem;
      border-radius: 100%;
      background-image: linear-gradient(yellow 50%, red 50%);
      transform: rotate(40deg);
      text-indent: -277.75rem;

      &::before {
        content: " ";
        position: absolute;
        top: 25%;
        left: 25%;
        width: 49%;
        height: 49%;
        background: black;
        border-radius: 100%;
      }
    }
  }

  .amex {
    width: 1.8rem;
    height: 1.2rem !important;
    line-height: 0.27rem;
    text-transform: uppercase;
    font-size: 0.1rem;
    font-weight: bold;
    background-image: repeating-radial-gradient(circle at center, #FFF 1px, #999 2px);
    font-style: italic;
    white-space: nowrap;
    border: 0.02rem solid #EEE;

    &::before {
      content: "american";
      position: absolute;
      left: 0.23rem;
      top: 0.2rem;
      padding-top: 0.12rem;
      padding-left: 0.07rem;
      width: 1.3rem;
      height: 0.77rem;
      text-align: left;
      background: #267AC3;
    }

    &::after {
      content: "express";
      position: absolute;
      left: 0.3rem;
      bottom: 0.25rem;
      padding-right: 0.05rem;
      width: 1.3rem;
    }
  }

  .visa {
    margin-top: 0.13rem;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.66rem;
    line-height: 0.5rem;
    font-style: oblique;

    &::before {
      content: " ";
      position: absolute;
      top: 0;
      left: -9px;
      display: block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0.33333rem 0.16667rem 0;
      border-color: transparent #ffffff transparent transparent;
    }
  }

  .jcb {
    padding: 0.05rem 0 0.04rem 0.05rem;
    height: 1rem !important;
    -webkit-border-radius: 0.13rem 0 0.13rem 0;
    background-color: white;
    font-style: normal;
    line-height: 1rem;

    .j,.c,.b {
      display: inline-block;
      margin-right: 0.02rem;
      width: 0.41rem;
      height: 100%;
      text-align: center;
      text-shadow: 0.02rem 0.02rem rgb(0 0 0 / 60%);
      border-radius: 0.13rem 0 0.13rem 0;
      -moz-border-radius: 0.13rem 0 0.13rem 0;
      -webkit-border-radius: 0.13rem 0 0.13rem 0;
    }

    .j {
      background-color: #000063;
      background-image: linear-gradient(to right,#000063, #008cff);
    }

    .c {
      background-color: #630000;
      background-image: linear-gradient(to right,#630000, #ff008d);
    }

    .b {
      background-color: #006300;
      background-image: linear-gradient(to right,#006300, #00ff00);
    }
  }

  .dinersclub {
    font-family: serif;
    width: 2.77rem;
    font-size: 0.47rem;
    font-style: normal;
    letter-spacing: 0.02rem;

    &::before {
      content: "Diners Club";
    }

    &::after {
      content: "International";
      display: block;
      text-transform: uppercase;
      font-size: 0.6em;
    }
  }

  .discover {
    right: 12% !important;
    top: 18% !important;
    padding-top: 7px;
    height: 1rem !important;
    width: 1.66667rem;
    font-family: inherit;
    color: #111;
    text-transform: uppercase;
    font-style: normal;
    font-weight: 500;
    font-size: 0.27778rem;
    text-align: center;
    overflow: hidden;
    letter-spacing: .02rem;
    background: #FF6600;
    border: 1px solid #EEE;
    box-shadow: 0 0 0 0.05556rem rgb(255 255 255 / 30%);
    z-index: 1;

    &::before {
      content: " ";
      position: absolute;
      bottom: -5%;
      right: -80%;
      width: 5.55rem;
      height: 5.55rem;
      background: white;
      border-radius: 5.55rem;
      z-index: -1;
    }

    &::after {
      content: "network";
      position: absolute;
      top: 0.27rem;
      left: 0.75rem;
      width: 0.22rem;
      height: 0.22rem;
      border-radius: 0.11rem;
      background-image: radial-gradient( #FF6600, #fff);
      font-size: 0.11rem;
      line-height: 0.66rem;
      text-indent: -0.19rem;
    }
  }

  .hipercard {
    font-size: 0.58rem;
    font-style: italic;
    font-weight: bold;
  }
}
</style>
